import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';
import View_Message_Editor from 'view/portal/message_editor';

export default View.extend({
    className: 'portal-new-comment',

    pending_xhr: [],

    views: {
        message_editor: {}
    },

    events: {
        'click .sign-in': 'onSignIn'
    },

    dom_handlers: {
        onSignIn: function(e) {
            e.preventDefault();

            if (this.embed === 'widget') {
                Modals.portalGuest();
            } else {
                Modals.signIn();
            }
        }
    },

    event_handlers: {
        onSubmit: function(message_data) {
            if (!message_data.comment) {
                return;
            }

            if (!Cache.real_user_id && !Cache.portal_user && !Cache.guest_user) {
                Modals.portalGuest();
                return;
            }

            this.views.message_editor.disable();

            var xhr = Cache.app.request({
                action: 'feedback\\Comment/add',
                data: {
                    id                      : this.feedback_id,
                    is_public               : message_data.is_public,
                    comment                 : message_data.comment,
                    attachment_file_name    : message_data.attachment.file_name,
                    attachment_file_content : message_data.attachment.file_content
                },
                complete: () => {
                    var index = this.pending_xhr.indexOf(xhr);

                    if (index !== -1) {
                        this.pending_xhr.splice(index, 1);
                    }

                    if (this.views.message_editor.enable) {
                        this.views.message_editor.enable();
                    }
                },
                success: (data) => {
                    Cache.feedback_comment.add(data);

                    this.views.message_editor.setText('', true);
                    UI.success('Comment added');
                }
            });

            this.pending_xhr.push(xhr);
        }
    },

    initialize: function(options) {
        this.feedback_id = options.feedback_id;
        this.embed       = options.embed;

        this.is_logged_in = (Cache.real_user_id || Cache.portal_user || Cache.guest_user) ? true : false;

        this.views.message_editor = new View_Message_Editor({
            model         : this.model,
            embed         : this.embed,
            public_toggle : Cache.real_user_id ? true : false,
            attachment    : true,
            placeholder   : this.is_logged_in ? 'Leave a comment here...' : 'Sign in to leave a comment...',
            has_submit    : this.is_logged_in,
            show_tools    : this.is_logged_in,
            disabled      : !this.is_logged_in,
            feedback_id   : this.feedback_id
        });

        this.views.message_editor.on('submit', this.event_handlers.onSubmit.bind(this));

        this.on('remove', () => {
            if (this.pending_xhr.length) {
                this.pending_xhr.forEach((xhr) => {
                    xhr.abort();
                });

                this.pending_xhr = [];
            }
        });
    },

    render: function() {
        var content =
        '<div class="region-message-editor">' +
            (this.is_logged_in ? '' :
            '<a class="sign-in" href="#">Sign In</a>') +
        '</div>';

        this.$el.html(content);
        this.views.message_editor.render().$el.appendTo(this.$el.find('.region-message-editor'));

        return this;
    }
});